import { type ExtendedLocationData, isNotEmpty, type TinyLocationData, type TinyResidentData } from '@terros/common'

export const getLocationPrimaryResident = (
  location: Pick<ExtendedLocationData, 'primaryResidents'> &
    Pick<TinyLocationData, 'resident'> & { residents?: TinyResidentData[] }
): TinyResidentData | undefined => {
  if (isNotEmpty(location.primaryResidents)) return location.primaryResidents.at(0)
  if (isNotEmpty(location.residents)) return location.residents.at(0)
  return location.resident
}
